export function setLocal(key: string, value: any) {
  localStorage.setItem(key, JSON.stringify(value))
}

export function setLocals(data: { [key: string]: any }): void {
  for (let key in data) {
    setLocal(key, data[key])
  }
}

export function getLocal(key: string): any {
  return JSON.parse(localStorage.getItem(key)!)
}

export function removeLocal(keys: string[]): any {
  for (let key of keys) {
    localStorage.removeItem(key)
  }
}
